import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Driver: "",
  },
};

const SliceBinTransferReport = createSlice({
  name: "SliceBinTransferReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_BinTransferReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_BinTransferReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_BinTransferReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_BinTransferReport_Init,
  Set_BinTransferReport_HeadObject_Set,
  Set_BinTransferReport_HeadObject_Init,
} = SliceBinTransferReport.actions;
export default SliceBinTransferReport.reducer;
